import "./BrandLogo.css";

export default function BrandLogo() {
  return (
    <span className="evr-logo" role="img" aria-label="evrwhz">
      <span className="evr-logo-text" aria-hidden="true">evr</span>
      <span className="evr-logo-mark" aria-hidden="true" />
      <span className="evr-logo-accent" aria-hidden="true">whz</span>
    </span>
  );
}
